import { defineComponent, ref, onMounted, computed, } from '@vue/composition-api';
import { getSurveyUserResponse, QuestionType, } from '@/api/v2/requests/surveys';
import { Icon } from '@/components/Icon';
import { mdiChevronLeft } from '@mdi/js';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
export default defineComponent({
    name: 'SurveyUserResponse',
    components: { Icon, TableLoader },
    setup(_, ctx) {
        const isLoading = ref(false);
        const surveyUserResponse = ref(null);
        const surveyId = computed(() => ctx.root.$route.params.surveyId);
        const userId = computed(() => ctx.root.$route.params.userId);
        const brandId = computed(() => ctx.root.$route.params.id);
        const getAnswerOptions = (answer) => {
            if (!answer)
                return [];
            const processItem = (item) => {
                const trimmed = item.trim();
                if (!trimmed)
                    return [];
                return trimmed.includes(';')
                    ? trimmed
                        .split(';')
                        .map((opt) => opt.trim())
                        .filter(Boolean)
                    : [trimmed];
            };
            const items = Array.isArray(answer) ? answer : [answer];
            const allOptions = items
                .filter((item) => typeof item === 'string')
                .flatMap(processItem);
            return [...new Set(allOptions)];
        };
        const getFileUrl = (filename) => {
            return Array.isArray(filename) ? filename[0] : filename;
        };
        const fetchSurveyUserResponse = async () => {
            if (!surveyId.value || !userId.value)
                return;
            isLoading.value = true;
            try {
                surveyUserResponse.value = await getSurveyUserResponse(surveyId.value, userId.value);
            }
            catch (error) {
                ctx.root.$toast.error(ctx.root.$t('brand-surveys.details.error-fetching-user-response'));
                surveyUserResponse.value = null;
            }
            finally {
                isLoading.value = false;
            }
        };
        const formatDate = (dateString) => {
            return new Date(dateString).toLocaleString(ctx.root.$i18n.locale);
        };
        onMounted(fetchSurveyUserResponse);
        return {
            isLoading,
            surveyUserResponse,
            surveyId,
            userId,
            brandId,
            formatDate,
            getAnswerOptions,
            getFileUrl,
            mdiChevronLeft,
            QuestionType,
        };
    },
});
